import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export const EmptyResults = () => (
  <div className="mx-auto h-full max-w-lg py-10">
    <div className="text-dark mb-1 text-center md:mb-4">
      <Typography.TitleMd as="h4" weight="semibold">
        {t("courses.admin_summary.engagement.quiz_results.empty.title")}
      </Typography.TitleMd>
      <div>
        <Typography.BodySm weight="medium">
          {t("courses.admin_summary.engagement.quiz_results.empty.description")}
        </Typography.BodySm>
      </div>
    </div>
  </div>
);
